import { Route, Routes } from 'react-router'

import { SUB_PATH } from '../../utils/routes'
import { NotFound } from '../common/NotFound'
import { Edit } from './Edit'
import { ListView } from './List'
import { Config } from './Config'

export const Appliances = () => {
  return (
    <Routes>
      <Route path={SUB_PATH.UPDATE} element={<Edit />} />
      <Route index element={<ListView />} />
      <Route path=":id/config" element={<Config />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
